import { ISolicitudPersonaValidarEmpresaModel } from "./interfaces/ISolicitudPersonaValidarEmpresaModel";

export class SolicitudPersonaValidarEmpresaModel implements ISolicitudPersonaValidarEmpresaModel {
    idTipoDocumentoIdentidad: number;
    nroDocumentoIdentidad: string;
    idContratista?: number;
    idSede: number;
    constructor() {
        this.idTipoDocumentoIdentidad = 0;
        this.nroDocumentoIdentidad = "";
        this.idContratista = 0;
        this.idSede = 0;
    }
}
